export default __webpack_public_path__ + "static/media/preloaderIcon.cff806a7.svg";